import React from 'react'
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from '../../header/Header';
import Sidebar from '../sidebar/SideBar';

// import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

const DetailView = () => {
  const { state } = useLocation()
  console.log(state);
  const details = state?.details
  const from = state?.from?.pathname
  const navigate = useNavigate()
  console.log(details.headline,'pppppppppppppppppppp');

  const handelBack = () => {
    console.log(from)
    navigate(from ? from :  '/admin/dashboard' , { replace: true })
  }
  const secondaryColor="#278D27"
  const textColor = '#FFFFFF'
  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header sprAdmin={true} />

        {/* Sidebar */}
        <Sidebar secondaryColor={secondaryColor} textColor={textColor} />

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row justify-content-center">
              <div className="col-lg-10 col-xl-9">
                {/* Blog Details*/}
                <div className="blog-view">
                  <div className="blog-single-post">
                    <p  className="back-btn" onClick={handelBack}>
                      <i className="feather-chevron-left cursor-pointer">
                        {/* <FeatherIcon icon="chevron-left" /> */}
                        Back
                      </i>
                    </p>
                    <div className="blog-image">
                      <Link to="#">
                        <img
                          alt=""
                          src={details?.image}
                          className="img-fluid"
                        />
                      </Link>
                    </div>
                    <h3 className="blog-title">
                      {details?.headline}
                    </h3>

                    <div className="blog-content">

                      <p>
                        {details?.description}
                      </p>

                    </div>
                  </div>

                </div>
              </div>
            </div>
            {/* /Blog Details*/}
          </div>
        </div>

      </div>
      {/* /Main Wrapper */}

    </>
  )
}

export default DetailView